import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrizacaoService } from '@core/services/parametrizacao.service';
import { MessageService } from '@core/services/message.service';
import { RouteAction } from '@core/action/action';

@Component({
  selector: 'app-parametrizacao-form',
  templateUrl: './parametrizacao-form.component.html',
  styleUrls: ['./parametrizacao-form.component.scss']
})
export class ParametrizacaoFormComponent implements OnInit {

  parametrizacaoForm!: FormGroup;
  idParams!: number;
  acao!: RouteAction;
  titulo!: string;
  inserir!: boolean;
  editar!: boolean;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private parametrizacaoService: ParametrizacaoService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.checkUrl();
    this.construirForm();
    if (this.editar) {
      this.buscarDados();
    }
  }

  construirForm() {
    this.parametrizacaoForm = this.fb.group({
      nome: ['', Validators.required],
      descricao: [''],
      value: ['', Validators.required]
    });
  }

  buscarDados() {
    if (this.idParams) {
      this.parametrizacaoService.buscarPorId(this.idParams).subscribe((res) => {
        this.parametrizacaoForm.patchValue(res);
      });
    }
  }

  submit() {
    if (this.parametrizacaoForm.invalid) {
      this.messageService.warning('Preencha todos os campos obrigatórios!');
      return;
    }

    const objSubmit = this.parametrizacaoForm.getRawValue();

    if (this.acao === RouteAction.Inserir) {
      this.parametrizacaoService.salvarOuAtualizar(objSubmit).subscribe(() => {
        this.messageService.success('Parâmetro cadastrado com sucesso!');
      });
    } else if (this.acao === RouteAction.Editar && this.idParams) {
      objSubmit.id = this.idParams;
      this.parametrizacaoService.salvarOuAtualizar(objSubmit).subscribe(() => {
        this.messageService.success('Parâmetro editado com sucesso!');
      });
    }
  }
  voltar() {
    window.history.back();
  }

  checkUrl() {
    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.inserir = this.acao === RouteAction.Inserir;
      this.editar = this.acao === RouteAction.Editar;
    });

    this.idParams = this.route.snapshot.params['id'];
    const nomeEditado = history.state.titulo;
    this.titulo =`${nomeEditado}`;
  }
}
